export default __webpack_public_path__ + "static/media/base_square_logo.6b02aa3e.svg";